module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "species-card",
    class: {
      reversed: _vm.isReversed
    }
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('img', {
    attrs: {
      "src": _vm.pictureUrl,
      "alt": "placeholder image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h4', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f20c9cae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/Card.vue
// module id = 863
// module chunks = 0